import React from 'react';

import style from './rank-row.module.scss';

const RankRow = ({ left, right }) => {
  const { score: leftScore, rank: leftRank } = left;
  const { score: rightScore, rank: rightRank } = right;

  const difference = rightScore - leftScore;

  return (
    <div className={style.rankRow}>
      <div className={style.side}>
        <div>
          <div className="font-mono">
            {!isNaN(parseFloat(leftScore)) ? parseFloat(leftScore).toFixed(2) : leftScore}
          </div>
          {difference > 0 && (
            <div
              className={`font-mono${
                difference > 0 ? ' text-red' : difference < 0 ? ' text-green' : ''
              }`}
            >
              {!isNaN(parseFloat(difference))
                ? (parseFloat(difference) * -1).toFixed(2)
                : ''}
            </div>
          )}
        </div>
        <div className={style.rank}>{leftRank ? `${leftRank}.` : ''}</div>
      </div>
      <div className={style.center} />
      <div className={style.side}>
        <div className={style.rank}>{rightRank ? `${rightRank}.` : ''}</div>
        <div>
          <div className="font-mono">
            {!isNaN(parseFloat(rightScore))
              ? parseFloat(rightScore).toFixed(2)
              : rightScore}
          </div>
          {difference <= 0 && (
            <div
              className={`font-mono${
                difference < 0 ? ' text-red' : difference > 0 ? ' text-green' : ''
              }`}
            >
              {!isNaN(parseFloat(difference)) ? parseFloat(difference).toFixed(2) : ''}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export { RankRow };
